import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    cancel: 'Cancel',
    ok: 'Got it',
    close: 'Close',
  },
  ru: {
    cancel: 'Отмена',
    ok: 'Понятно',
    close: 'Закрыть',
  },
  uz: {
    cancel: 'Bekor qilish',
    ok: 'Tushunarli',
    close: 'Yopish',
  },
  fa: {
    cancel: 'بی‌خیال',
    ok: 'باشه',
    close: 'بستن',
  },
  pt: {
    cancel: 'Cancelar',
    ok: 'Entendi',
    close: 'Fechar',
  },
  tr: {
    cancel: 'İptal',
    ok: 'Anladım',
    close: 'Kapat',
  },
});
